/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 *
 * The two ways the product references its own legal documents:
 *
 *   <LegalConsent/> — the clickwrap line under the signup button. Deliberately
 *     NOT a checkbox: the Terms bind on account creation ("By creating an
 *     account… you agree"), so an unticked box would imply an account could be
 *     created without agreeing, which isn't the deal being offered. A visible
 *     statement immediately above the action is the honest form of it.
 *
 *   <LegalFooter/> — the persistent pair, so the documents stay reachable after
 *     signup rather than only at the moment of consent.
 */
import { TERMS_URL, PRIVACY_URL, LEGAL_LINK_PROPS } from "../legalLinks.js";

export function LegalConsent({ action = "creating an account" }) {
  return (
    <p className="auth-foot muted legal-consent">
      By {action} you agree to our{" "}
      <a href={TERMS_URL} {...LEGAL_LINK_PROPS}>Terms of Service</a> and{" "}
      <a href={PRIVACY_URL} {...LEGAL_LINK_PROPS}>Privacy Policy</a>.
    </p>
  );
}

export function LegalFooter() {
  return (
    <footer className="app-legal-footer">
      <a href={TERMS_URL} {...LEGAL_LINK_PROPS}>Terms of Service</a>
      <span aria-hidden="true">·</span>
      <a href={PRIVACY_URL} {...LEGAL_LINK_PROPS}>Privacy Policy</a>
    </footer>
  );
}
